import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import LoggedAction from 'src/app/model/logged-action';
import { _post } from '../../base.service';
import { LoadingService } from '../../loading.service';
import { SnackService } from '../../snack.service';

@Injectable({
  providedIn: 'root',
})
export class ToggleImmoSubProjectExecutedControllerRequestService {
  private static BASE_URL = '/immo/toggleImmoSubProjectExecuted';
  private readonly post: <T>(
    path: string,
    body: null,
    deserialize: (response: any) => T
  ) => Observable<T>;

  private readonly deserializer = (res) =>
    res as ToggleImmoSubProjectExecutedResponse;

  constructor(
    http: HttpClient,
    snackService: SnackService,
    loadingService: LoadingService,
    router: Router
  ) {
    const requestServices = {
      http,
      loadingService,
      router,
      snackService,
    };
    this.post = _post(
      ToggleImmoSubProjectExecutedControllerRequestService.BASE_URL,
      requestServices
    );
  }

  public toggleImmoSubProjectExecuted(
    subProjectId: number
  ): Promise<ToggleImmoSubProjectExecutedResponse> {
    return this.post(`/${subProjectId}`, null, this.deserializer).toPromise();
  }
}

export interface ToggleImmoSubProjectExecutedResponse {
  placementDoneRegistration: LoggedAction;

  currentExecutionDate: Date;

  executionTime: string;

  subProjectIdWithNewStatus: SubProjectIdStatusPair[];
}

export interface SubProjectIdStatusPair {
  subProjectId: number;

  newStatus: string;
}
